<template lang="pug">
div
  y-dialog(v-model="showDialog" fullscreen max-width="600" persistent scrollable content-class="round-3xl")
    v-card.neutral200
      v-card-title.px-8.pt-8
        v-row(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="closeDialog" height)
              v-icon(color="basic800" :size="24") mdi-arrow-left
          v-col.ml-3
            .text-2xl.font-semibold.neutral700--text Select preferred time

      v-card-text.pa-8
        v-container.pa-0(style="max-width: 1000px;")
          //- Loading state
          template(v-if="isFetching")
            v-skeleton-loader.mb-6(type="text@4")
            v-skeleton-loader(type="text@4")
          //- Error state
          template(v-else-if="isError")
            v-card.pa-4.danger-border(outlined)
              .text-sm.danger500--text Opss.. An error occured
          //- Listing
          template(v-else)
            //- Pending sessions
            v-card.pa-8.round-xl.white.mb-6(v-if="pendingSessions.length > 0" outlined style="border-color: var(--v-neutral300) !important; border-width: 1.5px !important;")
              div.text-xl.font-semibold.neutral700--text.mb-6 Set appointment times for the slots below
              div(v-for="pendingSession in pendingSessions" :key="pendingSession.id")
                edit-recurring-session-item.mb-6(:session.sync="pendingSession" :hide-cancelled="hideCancelled" @refetch="refetch")
            //- Confirmed sessions
            v-card.pa-8.round-xl.white(v-if="confirmedSessions.length > 0" outlined style="border-color: var(--v-neutral300) !important; border-width: 1.5px !important;")
              div.text-xl.font-semibold.neutral700--text.mb-6 Edit selected appointment times
              div(v-for="confirmedSession in confirmedSessions" :key="confirmedSession.id")
                edit-recurring-session-item.mb-6(:session.sync="confirmedSession" :hide-cancelled="hideCancelled" @refetch="refetch")
      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        v-spacer
        v-btn.button-md.underline.px-0(text @click="closeDialog") {{ $t('close') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EditRecurringSessionItem from '@/components/clinic/appointment/advance/EditRecurringSessionItem.vue'

export default {
  components: {
    EditRecurringSessionItem,
  },
  props: {
    open: {
      type: Boolean
    },
    recurFor: {
      type: Number,
      default: null
    },
    hideCancelled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFetching: true,
      isError: false,
      pendingSessions: [],
      confirmedSessions: [],
      pageSize: -1,
    }
  },
  mounted () {
    this.fetchAppointment()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq',
      hqSelectedCompany: 'hq/getSelectedCompany'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    companySlug () {
      return this.isHq ? this.hqSelectedCompany.slug : this.company.slug
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async fetchAppointment () {
      try {
        this.isFetching = true
        let params = {
          page_size: this.pageSize,
          recur_for: this.recurFor
        }
        const { data } = await this.$axios.get(`/clinics/${this.companySlug}/appointments`, { params })
        if (data.count > 0) {
          const results = data.results.map((result, index) => ({...result, index}))
          this.pendingSessions = results.filter(session => session.status === 'pending')
          this.confirmedSessions = results.filter(session => session.status !== 'pending')
        }
      } catch (error) {
        this.isError = true
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isFetching = false
      }
    },
    refetch () {
      this.$emit('refetch')
      this.fetchAppointment()
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>